$(document).ready(function() {
	if ($(window).width() <= 768) {
		var mySwiper = new Swiper('.swiper-container',{
			// autoplay : 5000,//可选选项，自动滑动
			// loop : true,//可选选项，开启循环
			useCSS3Transforms : true,
			slidesPerView : 2,
			simulateTouch : false,
			slidesPerGroup : 2,
			resistance : "100%",
			onSlideChangeStart:function(){
				$('.swiper-slide.last').removeClass('last')
				$('.swiper-slide').eq(mySwiper.activeIndex + 1).addClass('last');			
			}
		});
	}else{
		var mySwiper = new Swiper('.swiper-container',{
			// autoplay : 5000,//可选选项，自动滑动
			// loop : true,//可选选项，开启循环
			useCSS3Transforms : true,
			slidesPerView : 4,
			simulateTouch : false,
			slidesPerGroup : 4,
			resistance : "100%",
			onSlideChangeStart:function(){
				$('.swiper-slide.last').removeClass('last')
				$('.swiper-slide').eq(mySwiper.activeIndex + 3).addClass('last');			
			}
		});	
	}
	

	$('.prev').click(function(){
		mySwiper.swipePrev() ; 
	});

	$('.next').click(function(){
		mySwiper.swipeNext(); 
	});

	$('.swiper-slide p').on('click', function(event) {
		
		var thisIndex = $(this).parent().index();
		$('.swiper-slide p').removeClass('active');
		$(this).addClass('active');
		$('.detail').addClass('hidden');
		$('.detail').eq(thisIndex).removeClass('hidden')
		
	});
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,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
